export default "__VITE_ASSET__B69yf5U9__"